import React from 'react';
import PropTypes from 'prop-types';

import { options } from './options';

const OptionList = ({ selectOption, currentPreference }) => (
  <>
    <h3 className="preferences-body-title">
      Select the type of notifications you want to receive:
    </h3>
    <ul className="preference-list">
      {options.map((option) => (
        <label key={option.value} htmlFor={`radio-${option.value}`} className="option">
          <input
            id={`radio-${option.value}`}
            type="radio"
            value={option.value}
            checked={currentPreference === option.value}
            onChange={(e) => selectOption(+e.target.value)}
          />
          {option.label}
        </label>
      ))}
    </ul>
  </>
);

OptionList.defaultProps = {
  selectOption: () => null,
  currentPreference: 1,
};

OptionList.propTypes = {
  selectOption: PropTypes.func,
  currentPreference: PropTypes.number,
};

export default OptionList;
